import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class ApiService {

  protected http = inject(HttpClient);

  get<T>(endpoint: string, params?: any): Observable<T> {
    return this.http.get<T>(`${environment.apiBaseUrl}/${endpoint}`, { params });
  }

  post<T>(endpoint: string, data: any, options?: { headers?: HttpHeaders | { [header: string]: string | string[] } }): Observable<T> {
    return this.http.post<T>(`${environment.apiBaseUrl}/${endpoint}`, data, options);
  }

  put<T>(endpoint: string, data: any): Observable<T> {
    return this.http.put<T>(`${environment.apiBaseUrl}/${endpoint}`, data);
  }

  patch<T>(endpoint: string, data: any): Observable<T> {
    return this.http.patch<T>(`${environment.apiBaseUrl}/${endpoint}`, data);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${environment.apiBaseUrl}/${endpoint}`);
  }

  customGet<T>(endpoint: string, params?: any): Observable<T> {
    return this.http.get<T>(`${environment.apiBaseUrl}/${endpoint}`, { params });
  }
}